import React from 'react'
import { Upload } from 'antd'

import type { ReactElement } from 'react'
import type { LntUploadDraggerProps } from './types'

export const LntUploadDragger = <FileType = File,>(
  props: LntUploadDraggerProps<FileType>
): ReactElement<LntUploadDraggerProps<FileType>> => {
  const { children, ...restProps } = props

  return <Upload.Dragger { ...restProps }>{ children }</Upload.Dragger>
}
